export enum EXERCISE_RESULT_MODE {
  SUCCESS = 0,
  NEUTRAL = 1,
  FAILURE = 2,
}
